import { Button, Modal, Progress } from 'antd';

import {
  GRADE_SCALE_MAX,
  getGradeColor,
} from '@app/components/LeadCard/ui/MessageHistory/components/AiGrade/lib';

import type { FC } from 'react';

import '../styles/AiGradeModal.scss';

const MODAL_RING_SIZE = 60;

interface AiGradeModalProps {
  grade: number;
  aiRecommendations: string | null;
  // Что оценено: «звонка» или «сообщения» — подставляется в заголовок.
  subject: string;
  open: boolean;
  onClose: () => void;
}

export const AiGradeModal: FC<AiGradeModalProps> = ({
  grade,
  aiRecommendations,
  subject,
  open,
  onClose,
}) => (
  <Modal
    centered
    className="AiGradeModal"
    destroyOnHidden
    footer={
      <Button type="primary" onClick={onClose}>
        Закрыть
      </Button>
    }
    open={open}
    title={null}
    onCancel={onClose}
  >
    <div className="AiGradeModal__content">
      <div className="AiGradeModal__title">
        Оценка {subject} {grade} из {GRADE_SCALE_MAX}
      </div>
      <Progress
        type="circle"
        percent={grade}
        size={MODAL_RING_SIZE}
        strokeWidth={8}
        strokeColor={getGradeColor(grade)}
        trailColor="rgba(0, 0, 0, 0.06)"
        format={() => grade}
      />
      {aiRecommendations && (
        <div className="AiGradeModal__recommendations">
          <div className="AiGradeModal__recommendations-title">
            Рекомендации по улучшению
          </div>
          <div className="AiGradeModal__recommendations-text">
            {aiRecommendations}
          </div>
        </div>
      )}
    </div>
  </Modal>
);
